import utilsApi from '../api/utils';

export const url = {
    created() {
        window.addEventListener("scroll", function () {
            window.lastScrollTime = new Date().getTime();
        });
    },
    methods: {
        checkUrl(url) {
            return utilsApi.checkUrl(url);
        },
        getUrl(url) {
            if (!url) {
                return null;
            }
            if (_.startsWith(url, '/')) {
                url = url.substring(1);
            }
            return '/' + this.$root.lang + '/' + url;
        },
        isScrolling() {
            return window.lastScrollTime && new Date().getTime() < window.lastScrollTime + 500
        },
        handleUrlHash() {
            let anchor  = window.location.hash.replace('#', ''),
                element = document.getElementById(anchor);
            if (!element) {
                return this.$nextTick(() => {
                    element = document.getElementById(anchor);
                    if (element) {
                        if (!this.isScrolling()) {
                            element.scrollIntoView({
                                behavior: 'smooth'
                            });
                        }
                    }
                });
            }

            this.$nextTick(() => {
                if (!this.isScrolling()) {
                    element.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        }
    }
};
